import React from 'react';
import { theme } from '../styles/theme';

export const styles: Record<string, React.CSSProperties> = {
  bottomNav: {
    position: 'fixed',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
    maxWidth: '430px',
    height: '80px',
    borderTop: '1px solid white',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '6px 16px 12px',
    zIndex: 1000,
    backgroundColor: theme.colors.background.wood,
    boxSizing: 'border-box',
  },
  navItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    textDecoration: 'none',
    padding: '4px 12px',
    minHeight: '44px',
    minWidth: '44px',
    borderRadius: '16px',
    transition: 'all 0.15s ease',
  },
  navItemActive: {
    color: theme.colors.nav.activeBackground,
  },
  navItemInactive: {
    color: theme.colors.text.gray800,
  },
  iconWrapper: {
    width: '48px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '14px',
  },
  iconWrapperActive: {
    backgroundColor: theme.colors.nav.activeBackground,
    borderBottom: '3px solid rgba(0, 0, 0, 0.15)',
  },
  label: {
    fontSize: '12px',
    fontWeight: '500',
  },
};
